export const COLUMN_SPANS = [2, 3, 1] as const

export const TOTAL_COLUMNS_SPAN = COLUMN_SPANS.reduce((acc, span) => acc + span, 0)
